import client from './main-client';

export const getAllUserCategoriesApi = (params) => client().get(`/document-categories/?userId=${params.userId}`, { params });

export const addCategoryApi = (data) => client().post('/document-categories', data);

// export const updateSpecDocsApi = (data) => client().put(`/specDocs/${data._id}`, data);

export const removeCategoryApi = (params) => client().delete(`/document-categories/${params._id}/?userId=${params.userId}`);
